/**
 * Placeholder do grid 2×2 de categorias documentais.
 * @module DocumentsChecklistSkeleton
 */

import { memo } from "react";
import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";

const CATEGORY_LABELS = [
  "Autorização Anvisa",
  "Receita médica",
  "Documento pessoal",
  "Comprovante de residência",
];

export default memo(function DocumentsChecklistSkeleton() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr 1fr",
        gap: 1.25,
        overflow: "hidden",
      }}
    >
      {CATEGORY_LABELS.map((label) => (
        <Card
          key={label}
          variant="outlined"
          sx={{
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            borderColor: "grey.200",
          }}
        >
          <CardContent
            sx={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              gap: 1.25,
              p: 1.5,
              "&:last-child": { pb: 1.5 },
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton variant="circular" width={28} height={28} />
              <Skeleton variant="text" width="55%" height={24} />
              <Skeleton
                variant="rounded"
                width={72}
                height={24}
                sx={{ ml: "auto" }}
              />
            </Stack>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Skeleton variant="rounded" height={44} />
              <Skeleton variant="rounded" height={28} width="40%" />
              <Stack direction="row" spacing={1}>
                <Skeleton variant="rounded" height={28} width={72} />
                <Skeleton variant="rounded" height={28} width={88} />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
});
